/** Kalendar ma'lumoti: `GET /api/widgets/data/calendar/` (doira va ruxsat backend'da); eslatma, driver, ariza, hujjat o'zgarsa yangilanadi. */
import { useEffect } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryClient } from "@/lib/queryClient";
import { subscribeEvents } from "@/lib/realtime";
import type { CalendarKind } from "./config";
import type { CalendarData } from "./dates";

const KEY = ["widgets", "data", "calendar"] as const;
const ENTITIES = new Set(["reminder", "driver", "application", "document", "driverdocument"]);

export function useCalendarEvents(from: string, to: string, kinds: CalendarKind[], enabled = true) {
  useEffect(() => {
    const off = subscribeEvents((ev) => {
      if (ENTITIES.has(ev.entity)) void queryClient.invalidateQueries({ queryKey: KEY });
    });
    return () => {
      off();
    };
  }, []);
  const kindsKey = kinds.join(",");
  return useQuery({
    queryKey: [...KEY, from, to, kindsKey],
    queryFn: () => api.get<CalendarData>("/api/widgets/data/calendar/", { query: { from, to, kinds: kindsKey } }),
    enabled,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
